import { Constants } from '@pwc/pwc-deals-web-common';

export const getViewClientInfo = (
  onShowClientVersion,
  onShowDraftVersion,
  versions,
  contentVersionNumber,
  contentVersionStatus
) => {
  return {
    onShowClientVersion,
    onShowDraftVersion,
    hasClientVersion:
      versions &&
      !!versions.find(
        (_) => _.versionStatus === Constants.VERSION_STATUS.SHARED.value
      ) &&
      versions.length !== 1,
    isOnClientVersion:
      versions &&
      contentVersionNumber &&
      contentVersionStatus &&
      !!versions.find((_) => _.versionNumber > contentVersionNumber) &&
      contentVersionStatus === Constants.VERSION_STATUS.SHARED.value,
  };
};
